import { lazy } from 'react';

const Home = lazy(() => import('./home'));
const Credit = lazy(() => import('./credit'));
const Deposit = lazy(() => import('./deposit'));
const Summary = lazy(() => import('./summary'));

export { Home, Credit, Deposit, Summary };
